import { ArrowBack } from "@mui/icons-material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { IconButton, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ActionBar } from "desktopWindow/components/DesktopWindow.styled";
import { useWindowTilesContext } from "desktopWindow/context/WindowTilesContext";
import { useEffect, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Page } from "react-pdf";
import { Document } from "react-pdf/dist/esm/entry.webpack";
import { getInvertColor } from "utils/themeUtils";
import { FileData } from "../../context/GameContext";
import { WindowContent, WindowTitleBar } from "../../desktopWindow/components/DesktopWindow";
import "./pdf-styles.css";
import { ToolIconButton } from "./ToolIconButton";
import { FileIcon } from "./FileTile";

interface Props {
	file: FileData;
	width: number;
	height: number;
	name: string | undefined;
	handleFileForMobile?: () => void;
	openFromApp?: boolean;
}
export const PDFViewer = ({ file, width, height, handleFileForMobile, name, openFromApp }: Props) => {
	const topBarHeight = 41;
	const taskBarHeight = 70;
	const TileHeadbars = 104;
	const heightPdfViewer = window.innerHeight - topBarHeight - taskBarHeight - TileHeadbars;
	const classes = useStyles({ height: isMobile ? heightPdfViewer : height });
	const { MobileWindowResized } = useWindowTilesContext();
	const [scale, setScale] = useState(0.95);
	const [numPages, setNumPages] = useState(null);
	const theme = useTheme();
	const zoomIn = () => {
		setScale((prev) => {
			const nextScale = prev + 0.2;
			if (nextScale >= 5) {
				return prev;
			}
			return nextScale;
		});
	};
	const zoomOut = () => {
		setScale((prev) => {
			const nextScale = prev - 0.2;
			if (nextScale < 0.2) {
				return prev;
			}
			return nextScale;
		});
	}; // Function to handle when the PDF is successfully loaded
	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	useEffect(() => {
		isMobile &&
			window.setTimeout(() => {
				MobileWindowResized("FileViewer", false);
			}, 50);
	}, [MobileWindowResized]);

	const toolbar = (
		<>
			{isMobile && openFromApp && (
				<IconButton
					color="inherit"
					onClick={handleFileForMobile}
					className={classes.backwardsButton}
					size="large"
				>
					<ArrowBack style={{ color: "white" }} />
				</IconButton>
			)}
			<ToolIconButton onClick={zoomOut}>
				<ZoomOutIcon fontSize="small" style={{ fill: getInvertColor(theme.palette.primary.main) }} />
			</ToolIconButton>
			<ToolIconButton onClick={zoomIn}>
				<ZoomInIcon fontSize="small" style={{ fill: getInvertColor(theme.palette.primary.main) }} />
			</ToolIconButton>
		</>
	);
	return (
		<>
			{(isDesktop || name) && (
				<WindowTitleBar
					icon={
						<div
							style={{
								display: "inline-block",
								width: 40,
								transform: "scale(0.5)", // Scaling down by 50%
								overflow: "hidden", // Optional, hides any overflow
							}}
						>
							<FileIcon fileData={file} />
						</div>
					}
				>
					{isDesktop && toolbar}
				</WindowTitleBar>
			)}
			{isMobile && <ActionBar style={{ paddingLeft: isMobile ? 0 : 24 }}>{toolbar}</ActionBar>}
			<WindowContent className={classes.windowContent}>
				<div
					style={{
						width: "100%",
						display: "flex",
						justifyContent: scale > 1 ? "initial" : "center", // Center horizontally
						alignItems: "flex-start", // Align items to the top
						overflow: "auto",
					}}
				>
					{" "}
					<div
						style={{
							display: "inline-block", // Ensures content is centered while allowing scroll
						}}
					>
						<Document file={file.fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
							{Array.from(new Array(numPages), (el, index) => (
								<Page key={`page_${index + 1}`} pageNumber={index + 1} width={width * scale} />
							))}
						</Document>
					</div>
				</div>
			</WindowContent>
		</>
	);
};

const useStyles = makeStyles((theme) => ({
	backwardsButton: {
		[theme.breakpoints.down("mobile")]: {
			padding: 6,
			marginLeft: 10,
			position: "absolute",
			left: 8,
		},
	},
	windowContent: {
		backgroundColor: "#eee",
		display: "flex",
		justifyContent: "center",
		// minHeight: (props: any) => props.height,
		height: "100%",
	},
}));
